import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ t, onQuoteClick }) => {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center overflow-hidden bg-black"
    >
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#001a3d] via-black to-black" />
      {/* Grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
          maskImage:
            'radial-gradient(ellipse at 50% 30%, black 35%, transparent 75%)',
        }}
      />
      {/* Glow */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-[#004aad]/20 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-[#004aad]/10 blur-[120px] rounded-full" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 pt-32 pb-24 w-full text-center">
        <div className="inline-flex items-center gap-2 border border-white/10 bg-white/5 backdrop-blur rounded-full px-4 py-1.5 mb-8">
          <span className="h-2 w-2 rounded-full bg-[#004aad] animate-pulse" />
          <span className="text-xs tracking-[0.25em] text-zinc-300">
            {t.hero.eyebrow.toUpperCase()}
          </span>
        </div>

        <h1 className="text-white font-extrabold leading-[1.02] tracking-tight text-5xl md:text-6xl lg:text-7xl">
          {t.hero.title1}{' '}
          <span className="relative inline-block">
            <span className="relative z-10 text-[#5b8def]">
              {t.hero.titleHighlight}
            </span>
            <span className="absolute left-0 bottom-2 h-3 w-full bg-[#004aad]/30 -z-0" />
          </span>
          <br />
          {t.hero.title2}
        </h1>

        <p className="mt-7 text-lg lg:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
          {t.hero.subtitle}
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={onQuoteClick}
            className="h-14 px-8 bg-[#004aad] hover:bg-[#0057cc] text-white rounded-full text-base font-medium group"
          >
            {t.hero.cta2}
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            variant="outline"
            onClick={() =>
              document.getElementById('what')?.scrollIntoView({ behavior: 'smooth' })
            }
            className="h-14 px-8 border-white/20 bg-transparent text-white hover:bg-white/5 hover:text-white rounded-full text-base font-medium"
          >
            {t.hero.cta1}
            <ArrowDown className="ml-2 h-4 w-4" />
          </Button>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {t.hero.stats.map((s) => (
            <div
              key={s.label}
              className="text-center md:text-left md:border-l md:border-white/10 md:pl-4"
            >
              <div className="text-2xl md:text-3xl font-bold text-white">
                {s.value}
              </div>
              <div className="text-xs text-zinc-500 mt-1 tracking-wide">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-zinc-500 text-xs tracking-[0.3em] flex flex-col items-center gap-2 animate-bounce">
        SCROLL
        <ArrowDown className="h-3 w-3" />
      </div>
    </section>
  );
};

export default Hero;
